<script lang="ts">
  import AuthCard from "./AuthCard.svelte";

  import { createUserWithEmailAndPassword } from "firebase/auth";
  import { firebaseAuth, refreshFirebaseToken } from "$utils/firebase/client";
  import { createEventDispatcher, onMount } from "svelte";
  import { baseAppUrl, loginUrl, userHomeUrl } from "$utils/urls";
  import api, { apiClientConfig } from "$utils/api";
  import { auth, session } from "$stores/auth";
  import { page } from "$app/stores";
  import { createUser } from "$utils/auth";

  export let inModal = false;
  export let joiningCommunity: string | undefined = undefined;

  const dispatch = createEventDispatcher();
  let firebaseError: string;

  onMount(() => {
    // prevent auth handlers from pre-emptively moving us along flow
    $auth.unsubscribe();
  });

  async function signUp(email: string, password: string, captcha: string) {
    // this is to prevent the top level +page.svelte / +layout.ts from redirecting to verify-email too soon.
    $session.insideAuthFlow = true;
    try {
      const user = await createUserWithEmailAndPassword(firebaseAuth, email, password);
      const result = await createUser(user, captcha);
      if (!result) {
        firebaseError = "Invalid email or password";
        $auth.loading = false;
        return;
      }
      // when auth store has refreshed the token, send email verification
      await refreshFirebaseToken(firebaseAuth.currentUser!, apiClientConfig);
      await api.apiUsersSendEmailVerification({
        emailVerification: {
          communitySlug: joiningCommunity || "",
          // @ts-ignore
          redirectUrl: new URL(userHomeUrl(), window.location).href,
          baseFrontendUrl: baseAppUrl($page.url),
        },
      });
      dispatch("authed", { user });
    } catch {
      firebaseError = "Invalid email or password";
    }
  }
</script>

<AuthCard
  on:submit={(event) => signUp(event.detail.email, event.detail.password, event.detail.captcha)}
  on:authed={(ev) => {
    createUser(ev.detail.user, "").then((success) => success && dispatch("authed", ev.detail));
  }}
  buttonText="Continue with email"
  heading="Create your account"
  emailPlaceholder="Company email"
  passwordPlaceholder="Password - 8 character minimum"
  hasBackground={inModal}
  showOutverseLogo={!inModal}
  isSignUp
>
  <div slot="subheading" class="pt-4 text-sm font-medium">
    {#if inModal}
      <button class="text-blue-300" on:click|stopPropagation={() => dispatch("requestSignIn")}>
        <span class="text-gray-400">Already have an Outverse account?</span>
        Log in
      </button>
    {:else}
      <a href={loginUrl()} class="text-blue-300">
        <span class="text-gray-400">Already have an Outverse account?</span>
        Log in
      </a>
    {/if}
  </div>

  <div slot="footer" class="mt-4 text-xs font-medium text-gray-400">
    <span>By signing up, you agree to our</span>
    <a
      href="https://www.outverse.com/terms-conditions"
      class="text-xxs text-white"
      target="_blank"
      rel="noreferrer"
    >
      Terms & Conditions
    </a>
  </div>

  <div slot="error">
    {#if firebaseError}
      {firebaseError}
    {/if}
  </div>
</AuthCard>
